import $ from "jquery";
// import { notify } from '../notification/notification';
// import { closeSections } from '../navbar-section/navbar-section';

export function initMenu() {
  $(function () {
    $(".js-menu").on("click", (e: Event) => {
      e.preventDefault();
      if ($(e.target!).siblings().hasClass("active")) {
        $(".js-menu-options").removeClass("active");
      } else {
        $(".js-menu-options").removeClass("active");
        $(e.target!).siblings().addClass("active");
      }
    });
    $(".menutop").hover(function () {
      $(".js-menu-options").removeClass("active");
    });

    $(".js-menu-mobile").on("click", (e: Event) => {
      e.preventDefault();
      $(".js-menu-options").removeClass("active");
      if ($(".js-menu-mobile-options").hasClass("active")) {
        $(".js-menu-mobile-options").removeClass("active");
      } else {
        $(".js-menu-mobile-options").addClass("active");
      }

    });
    $(".js-lang-selector").on("click", (e: Event) => {
      e.preventDefault();
      const options = $(".lang-selector .options");
      const layer = $(".lang-selector .layer");
      if (options.hasClass("active")) {
        options.removeClass("active");
        layer.removeClass("active");
      } else {
        options.addClass("active");
        layer.addClass("active");
      }
    });
    $(".js-lang-layer").on("click", (e: Event) => {
      e.preventDefault();
      const options = $(".lang-selector .options");
      const layer = $(".lang-selector .layer");
      if (options.hasClass("active")) {
        options.removeClass("active");
        layer.removeClass("active");
      } else {
        options.addClass("active");
        layer.addClass("active");
      }
    });

  });
}
